import isEmail from 'validator/lib/isEmail';
import isCreditCard from 'validator/lib/isCreditCard';
import isStrongPassword from 'validator/lib/isStrongPassword';
import isDate from 'validator/lib/isDate';
import isDecimal from 'validator/lib/isDecimal';
const phoneRegex = /^[+]?[0-9]+$/;
const lettersOnly = /^[À-ÿa-zA-Z_\-'. ]*$/;
const alphabetWithAllowedSpecialChars = /^[a-zA-ZàÀáÁâÂäÄèÈéÉêÊëËìÌíÍîÎïÏòÒóÓôÔöÖÿŸùÙúÚûÛüÜçÇñÑ'\-/\s]{1,50}$/;
const alphabetsOnly = /[^À-ÿa-zA-Z]/g;
const alphabetCheck = /[^À-ÿa-zA-Z]+/;
const otpRegex = /^\d{4,6}$/;
const cvvRegex = /^[0-9]{3,4}$/;
const alphaNumFlightNo = /^(?=.*[\d^'])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/;
export const validateDate = (val) => !!val && isDate(val, { format: 'DD/MM/YYYY', strictMode: true });
export const validateDecimalNumber = (val) => 
// eslint-disable-next-line camelcase
!!val && isDecimal(val, { force_decimal: false, decimal_digits: '1,' });
export const validateEmail = (val) => !!val && isEmail(val, {});
export const validateAlphaNumFlightNo = (val) => !!val && alphaNumFlightNo.test(val);
export const validateName = (val) => !!val && lettersOnly.test(val);
export const validateMobile = (val, minLength, maxLength) => {
    if (val && minLength && maxLength) {
        const phoneRegexStr = `^[+]?[0-9]{${minLength},${maxLength}}$`;
        const phoneRegexWithLength = new RegExp(phoneRegexStr);
        return phoneRegexWithLength.test(val);
    }
    return !!val && phoneRegex.test(val);
};
export const validateCardNumber = (val) => !!val && isCreditCard(val);
export const validatOTP = (val) => !!val && otpRegex.test(val);
export const validateNameWithAllowedSpecialChars = (val) => {
    var _a;
    if (!val) {
        return false;
    }
    // #### This is to check starting must be from alphabet
    const firstLetter = (_a = val === null || val === void 0 ? void 0 : val.trim()) === null || _a === void 0 ? void 0 : _a.charAt(0);
    if (alphabetCheck.test(firstLetter)) {
        return false;
    }
    // #### This is to check at least 2 alphabet must be present apart from special chars
    if (alphabetWithAllowedSpecialChars.test(val)) {
        const valWithoutSpecialChars = val.replaceAll(alphabetsOnly, '');
        if (valWithoutSpecialChars.length < 2) {
            return false;
        }
        return true;
    }
    return false;
};
export const validateCVV = (isAmexSelected, val) => {
    if (!!val && cvvRegex.test(val)) {
        if (isAmexSelected && (val === null || val === void 0 ? void 0 : val.length) === 4) {
            return true;
        }
        if (!isAmexSelected && (val === null || val === void 0 ? void 0 : val.length) === 3) {
            return true;
        }
    }
    return false;
};
export const validateCardExpiryDate = (val) => {
    if (!val) {
        return false;
    }
    const parsedYear = Number(val.substring(3, 5));
    const parsedMonth = Number(val.substring(0, 2));
    if (Number.isNaN(parsedYear) || Number.isNaN(parsedMonth)) {
        return false;
    }
    const currentMonth = new Date().getMonth() + 1;
    const currentYear = Number(new Date().getFullYear().toString().substring(2));
    if (parsedMonth === 0 || parsedMonth > 12) {
        return false;
    }
    if (parsedYear < currentYear) {
        return false;
    }
    if (parsedYear === currentYear && parsedMonth <= currentMonth) {
        return false;
    }
    return true;
};
// Can add password rules here as second parameter  https://www.npmjs.com/package/validator
export const validateStrongPassword = (value) => !!value &&
    isStrongPassword(value, {
        minLength: 8,
        minLowercase: 1,
        minUppercase: 1,
        minNumbers: 1,
        minSymbols: 0,
        returnScore: false,
        pointsPerUnique: 1,
        pointsPerRepeat: 0.5,
        pointsForContainingLower: 10,
        pointsForContainingUpper: 10,
        pointsForContainingNumber: 10,
        pointsForContainingSymbol: 10,
    });
export const validateCovidCheckbox = (val) => {
    return val === 'true' ? null : false;
};
export const validateInput = (val) => {
    return !!val;
};
